/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardEsercentiDTO { 
    /**
     * Esercenti convenzionati = domande esercente in stato ABILITATA
     */
    convenzionati?: number;
    rimborsi_pagati?: number;
    rimborsi_in_coda?: number;
    importo_rimborsato?: number;
}

